import TokenService from "../../services/tokenService";

const state = {
  tablesStates: {}
}

const getters = {
  getStateForTable: (state) => (identifier) => {
    return state.tablesStates[identifier]
  }
};

const actions = {

  persistTableState({ commit }, data) {
    commit('didPersistTableState', data)
  }

}

const mutations = {

  didPersistTableState(state, data) {
    console.log(data)
    state.tablesStates[data.identifier] = data
  },

  didLogOut(state) {
    state.tablesStates = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/b122Table.js